import type { RoomOptions, TrackPublishDefaults } from "livekit-client";

/**
 * R-03 - only the customer's camera is recorded (R-01) and the merge copies video without
 * transcoding, so every guest room publishes H264; no backup codec so egress never sees a
 * second codec; simulcast off so the recorded layer is the published one (Claude's discretion,
 * Pitfall 6); module scope because LiveKitRoom restarts the camera when options change identity
 * (T-04-43).
 */
export const GUEST_PUBLISH_DEFAULTS: TrackPublishDefaults = {
  videoCodec: 'h264',
  backupCodec: false,
  simulcast: false,
};

export const GUEST_ROOM_OPTIONS: RoomOptions = {
  publishDefaults: GUEST_PUBLISH_DEFAULTS,
};
